import { CONSORS_SUBSCRIBERS } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsSubscriberEnum = z.nativeEnum(CONSORS_SUBSCRIBERS);
export type SchemaConsorsSubscriberEnum = z.infer<typeof schemaConsorsSubscriberEnum>;
